import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  dashboardData : null,
  error : null
};


export const DASHBOARD_URL = "admin/user/dashboard";

export const getDashboardData = createAsyncThunk(
    DASHBOARD_URL,
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(DASHBOARD_URL);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

const dashboardSlice = createSlice({
    name : "dashboard",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(getDashboardData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getDashboardData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.dashboardData = action.payload;
            })
            .addCase(getDashboardData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default dashboardSlice.reducer